import { render, staticRenderFns } from "./form-wizard.generic.vue?vue&type=template&id=2f49a7f7&"
import script from "./form-wizard.generic.vue?vue&type=script&lang=js&"
export * from "./form-wizard.generic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports